import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainArticlesSucceed, EGetMainArticlesActionType } from './types';
import { IMainArticles } from '../../../types/mainArticles';

export const getMainArticlesSucceed: (data: IMainArticles) => TGetMainArticlesSucceed = actionGenerator<
  EGetMainArticlesActionType.Succeed,
  IMainArticles
>(EGetMainArticlesActionType.Succeed);
